export default __webpack_public_path__ + "static/media/eyes_strikethrough.red.e8ed22dc.svg";